import { default as iframet9WXTFToqkMeta } from "/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/chirashi/iframe.vue?macro=true";
import { default as index26RuZhLSuqMeta } from "/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/chirashi/index.vue?macro=true";
import { default as viewerywahQHpQ9oMeta } from "/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/chirashi/viewer.vue?macro=true";
import { default as _91id_93d2RfcSFu2rMeta } from "/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/content/[id].vue?macro=true";
import { default as indexssWNOl46EtMeta } from "/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/faq/index.vue?macro=true";
import { default as index0ZcpK63tvOMeta } from "/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/index.vue?macro=true";
import { default as indexxCsMgoRYhBMeta } from "/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/maker-theme/index.vue?macro=true";
import { default as indexGheiTGXcQpMeta } from "/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/maker-theme/survey/index.vue?macro=true";
import { default as indexTHJggGaWw0Meta } from "/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/my-store/index.vue?macro=true";
import { default as _91type_93yhLJRRIn0DMeta } from "/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/my-store/search/[type].vue?macro=true";
import { default as indexYxnQZ3KQ36Meta } from "/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/my-store/search/index.vue?macro=true";
import { default as indexP6OIBzkQU9Meta } from "/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/preview/chirashi/index.vue?macro=true";
import { default as viewerfOlPG9YVwxMeta } from "/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/preview/chirashi/viewer.vue?macro=true";
import { default as indexBPOMl66ZMhMeta } from "/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/privacy-policy/index.vue?macro=true";
import { default as indexZITpdMaXsKMeta } from "/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/product/index.vue?macro=true";
import { default as indexli4ZFUcS7KMeta } from "/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/theme/index.vue?macro=true";
export default [
  {
    name: iframet9WXTFToqkMeta?.name ?? "chirashi-iframe",
    path: iframet9WXTFToqkMeta?.path ?? "/chirashi/iframe",
    meta: iframet9WXTFToqkMeta || {},
    alias: iframet9WXTFToqkMeta?.alias || [],
    redirect: iframet9WXTFToqkMeta?.redirect || undefined,
    component: () => import("/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/chirashi/iframe.vue").then(m => m.default || m)
  },
  {
    name: index26RuZhLSuqMeta?.name ?? "chirashi",
    path: index26RuZhLSuqMeta?.path ?? "/chirashi",
    meta: index26RuZhLSuqMeta || {},
    alias: index26RuZhLSuqMeta?.alias || [],
    redirect: index26RuZhLSuqMeta?.redirect || undefined,
    component: () => import("/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/chirashi/index.vue").then(m => m.default || m)
  },
  {
    name: viewerywahQHpQ9oMeta?.name ?? "chirashi-viewer",
    path: viewerywahQHpQ9oMeta?.path ?? "/chirashi/viewer",
    meta: viewerywahQHpQ9oMeta || {},
    alias: viewerywahQHpQ9oMeta?.alias || [],
    redirect: viewerywahQHpQ9oMeta?.redirect || undefined,
    component: () => import("/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/chirashi/viewer.vue").then(m => m.default || m)
  },
  {
    name: _91id_93d2RfcSFu2rMeta?.name ?? "content-id",
    path: _91id_93d2RfcSFu2rMeta?.path ?? "/content/:id()",
    meta: _91id_93d2RfcSFu2rMeta || {},
    alias: _91id_93d2RfcSFu2rMeta?.alias || [],
    redirect: _91id_93d2RfcSFu2rMeta?.redirect || undefined,
    component: () => import("/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/content/[id].vue").then(m => m.default || m)
  },
  {
    name: indexssWNOl46EtMeta?.name ?? "faq",
    path: indexssWNOl46EtMeta?.path ?? "/faq",
    meta: indexssWNOl46EtMeta || {},
    alias: indexssWNOl46EtMeta?.alias || [],
    redirect: indexssWNOl46EtMeta?.redirect || undefined,
    component: () => import("/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/faq/index.vue").then(m => m.default || m)
  },
  {
    name: index0ZcpK63tvOMeta?.name ?? "index",
    path: index0ZcpK63tvOMeta?.path ?? "/",
    meta: index0ZcpK63tvOMeta || {},
    alias: index0ZcpK63tvOMeta?.alias || [],
    redirect: index0ZcpK63tvOMeta?.redirect || undefined,
    component: () => import("/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexxCsMgoRYhBMeta?.name ?? "maker-theme",
    path: indexxCsMgoRYhBMeta?.path ?? "/maker-theme",
    meta: indexxCsMgoRYhBMeta || {},
    alias: indexxCsMgoRYhBMeta?.alias || [],
    redirect: indexxCsMgoRYhBMeta?.redirect || undefined,
    component: () => import("/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/maker-theme/index.vue").then(m => m.default || m)
  },
  {
    name: indexGheiTGXcQpMeta?.name ?? "maker-theme-survey",
    path: indexGheiTGXcQpMeta?.path ?? "/maker-theme/survey",
    meta: indexGheiTGXcQpMeta || {},
    alias: indexGheiTGXcQpMeta?.alias || [],
    redirect: indexGheiTGXcQpMeta?.redirect || undefined,
    component: () => import("/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/maker-theme/survey/index.vue").then(m => m.default || m)
  },
  {
    name: indexTHJggGaWw0Meta?.name ?? "my-store",
    path: indexTHJggGaWw0Meta?.path ?? "/my-store",
    meta: indexTHJggGaWw0Meta || {},
    alias: indexTHJggGaWw0Meta?.alias || [],
    redirect: indexTHJggGaWw0Meta?.redirect || undefined,
    component: () => import("/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/my-store/index.vue").then(m => m.default || m)
  },
  {
    name: _91type_93yhLJRRIn0DMeta?.name ?? "my-store-search-type",
    path: _91type_93yhLJRRIn0DMeta?.path ?? "/my-store/search/:type()",
    meta: _91type_93yhLJRRIn0DMeta || {},
    alias: _91type_93yhLJRRIn0DMeta?.alias || [],
    redirect: _91type_93yhLJRRIn0DMeta?.redirect || undefined,
    component: () => import("/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/my-store/search/[type].vue").then(m => m.default || m)
  },
  {
    name: indexYxnQZ3KQ36Meta?.name ?? "my-store-search",
    path: indexYxnQZ3KQ36Meta?.path ?? "/my-store/search",
    meta: indexYxnQZ3KQ36Meta || {},
    alias: indexYxnQZ3KQ36Meta?.alias || [],
    redirect: indexYxnQZ3KQ36Meta?.redirect || undefined,
    component: () => import("/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/my-store/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexP6OIBzkQU9Meta?.name ?? "preview-chirashi",
    path: indexP6OIBzkQU9Meta?.path ?? "/preview/chirashi",
    meta: indexP6OIBzkQU9Meta || {},
    alias: indexP6OIBzkQU9Meta?.alias || [],
    redirect: indexP6OIBzkQU9Meta?.redirect || undefined,
    component: () => import("/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/preview/chirashi/index.vue").then(m => m.default || m)
  },
  {
    name: viewerfOlPG9YVwxMeta?.name ?? "preview-chirashi-viewer",
    path: viewerfOlPG9YVwxMeta?.path ?? "/preview/chirashi/viewer",
    meta: viewerfOlPG9YVwxMeta || {},
    alias: viewerfOlPG9YVwxMeta?.alias || [],
    redirect: viewerfOlPG9YVwxMeta?.redirect || undefined,
    component: () => import("/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/preview/chirashi/viewer.vue").then(m => m.default || m)
  },
  {
    name: indexBPOMl66ZMhMeta?.name ?? "privacy-policy",
    path: indexBPOMl66ZMhMeta?.path ?? "/privacy-policy",
    meta: indexBPOMl66ZMhMeta || {},
    alias: indexBPOMl66ZMhMeta?.alias || [],
    redirect: indexBPOMl66ZMhMeta?.redirect || undefined,
    component: () => import("/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/privacy-policy/index.vue").then(m => m.default || m)
  },
  {
    name: indexZITpdMaXsKMeta?.name ?? "product",
    path: indexZITpdMaXsKMeta?.path ?? "/product",
    meta: indexZITpdMaXsKMeta || {},
    alias: indexZITpdMaXsKMeta?.alias || [],
    redirect: indexZITpdMaXsKMeta?.redirect || undefined,
    component: () => import("/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexli4ZFUcS7KMeta?.name ?? "theme",
    path: indexli4ZFUcS7KMeta?.path ?? "/theme",
    meta: indexli4ZFUcS7KMeta || {},
    alias: indexli4ZFUcS7KMeta?.alias || [],
    redirect: indexli4ZFUcS7KMeta?.redirect || undefined,
    component: () => import("/Users/taichi.anzo/work/DandS/chirashi-viewer/pages/theme/index.vue").then(m => m.default || m)
  }
]